import { get } from '../utils';
import { toast } from '../components';
import { runInAction } from 'mobx';
import wx from 'jweixin-1.6.0'

// 获取微信分享的signature, appid, noncestr, timestamp
export default function getWXSignature(title, desc, link, imgUrl): any {
    let signatureInfo: any = {}
    let signLink: any = sessionStorage.getItem('init_url')
    let user_agent = navigator.userAgent.toLowerCase();
    if (/iphone|ipad|ipod/.test(user_agent)) {   //iphone
        signLink = encodeURIComponent(signLink)
    }
    // alert(`signLink: ${signLink}`)
    return get('user/sys/v1/wx/getSignature?url=' + signLink).then((res) => {
        // alert(`res: ${JSON.stringify(res.data)}`)
        if (res.errCode == 200) {
            runInAction(() => {
                signatureInfo = {
                    signature: res.data.signature,
                    appId: res.data.appId,
                    noncestr: res.data.noncestr,
                    timestamp: res.data.timestamp,
                }
            });
            wx.config({
                // debug: true,
                signature: res.data.signature,
                appId: res.data.appId,
                nonceStr: res.data.noncestr,
                timestamp: res.data.timestamp,
                jsApiList: [
                    'onMenuShareAppMessage', //1.0 分享到朋友
                    'onMenuShareTimeline', //1.0分享到朋友圈
                    'updateAppMessageShareData', //1.4 分享到朋友
                    'updateTimelineShareData', //1.4分享到朋友圈
                ] // 必填，需要使用的JS接口列表，所有JS接口列表见附录2
            });
            // 微信分享
            wx.ready(function () {
                console.log("ready-start")
                let shareData = {
                    title: title,
                    desc: desc,
                    link: link,
                    imgUrl: imgUrl,
                    trigger: function (res) {
                        // 不要尝试在trigger中使用ajax异步请求修改本次分享的内容，因为客户端分享操作是一个同步操作，这时候使用ajax的回包会还没有返回
                        //alert('用户点击发送给朋友');
                    },
                    success: function (res) {

                        //window.location.href = "http://t.cn/RZmX3L7" ;
                    },
                    cancel: function (res) {
                        //alert('已取消');
                    },
                    fail: function (res) {
                        //alert(JSON.stringify(res));
                    }
                }
                if (wx.onMenuShareAppMessage) { //微信文档中提到这两个接口即将弃用，故判断
                    wx.onMenuShareAppMessage(shareData);//1.0 分享到朋友
                    wx.onMenuShareTimeline(shareData);//1.0分享到朋友圈
                } else {
                    wx.updateAppMessageShareData(shareData);//1.4 分享到朋友
                    wx.updateTimelineShareData(shareData);//1.4分享到朋友圈
                }

            });
            return signatureInfo;

        } else {
            toast(res.errDesc)
        }
    });
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/operates/getWXSignature.ts